import { stockFormEmail } from '@raywhite/functionalities-utils/lib/functionalities/form'
import { fields, labels } from './CommercialSellAppraisalForm.jsx'
// eslint-disable-next-line no-restricted-exports
export { default, validate } from './CommercialSellAppraisalForm.jsx'

export const process = (values, { send, referrer }) => stockFormEmail(
  send,
  'Commercial Lease Appraisal Request',
  fields,
  labels,
  values,
  {
    prefix: `A commercial lease appraisal request has been received from ${referrer || 'your office website'}.`,
    referrer,
  }
)
